import React from 'react';

import Button, { BUTTON_VARIANTS } from 'js/src/components/common/ui/Button';

export enum SOCIAL_BUTTON_PROVIDERS {
    GOOGLE = 'google',
    FACEBOOK = 'facebook',
    SSO = 'sso',
}

type SocialButtonProps = {
    provider: SOCIAL_BUTTON_PROVIDERS;
    text: string;
    onClick?: (e: React.MouseEvent) => void;
    href?: string;
    className?: string;
    'data-testid'?: string;
};

const SocialButton: React.FC<SocialButtonProps> = ({
    provider,
    text,
    onClick = () => {},
    href,
    className = '',
    'data-testid': dataTestId,
}) => {
    const getProviderIcon = () => {
        switch (provider) {
            case SOCIAL_BUTTON_PROVIDERS.GOOGLE:
                return (
                    <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M17.64 9.205c0-.639-.057-1.252-.164-1.841H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"
                            fill="#4285F4"
                        />
                        <path
                            d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z"
                            fill="#34A853"
                        />
                        <path
                            d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z"
                            fill="#FBBC05"
                        />
                        <path
                            d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z"
                            fill="#EA4335"
                        />
                    </svg>
                );
            case SOCIAL_BUTTON_PROVIDERS.FACEBOOK:
                return (
                    <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M18 9.048c0-4.986-4.043-9.028-9.029-9.028S-.058 4.062-.058 9.048c0 4.508 3.305 8.25 7.632 8.924v-6.315H5.335V9.048h2.239V7.055c0-2.211 1.318-3.433 3.333-3.433.966 0 1.977.172 1.977.172v2.173h-1.114c-1.097 0-1.44.681-1.44 1.38v1.658h2.45l-.392 2.609H10.33v6.315c4.327-.674 7.632-4.416 7.632-8.924z"
                            fill="#1877F2"
                        />
                    </svg>
                );
            case SOCIAL_BUTTON_PROVIDERS.SSO:
                return (
                    <i translate="no" className="material-symbols-outlined">
                        key
                    </i>
                );
            default:
                throw new Error('Unsupported provider');
        }
    };

    return (
        <Button
            className={`social-button d-flex align-items-center justify-content-center w-100 font-l5 font-l5--small bg-social ${className}`}
            variant={BUTTON_VARIANTS.OUTLINE}
            onClick={onClick}
            data-testid={dataTestId}
            iconLeft={getProviderIcon()}
            text={text}
            href={href}
        />
    );
};

export default SocialButton;
